<!-- <div class="wrapperi">
  <div class="container">
    <div class="wrap">

      <div class="col-12 m-0 row">
        <div class="col-3"></div>
        <div class="col-12 col-md-6 p-0 mt-4">
          <div class="col-12 text-center p-0">
            <h4 class="header-text mt-4">Aktivoi käyttäjäsi</h4>
            <p class="desc-text">Syötä haluamasi salasana. <span class="desc-text-bold">Saat onnistumisilmoituksen onnistuneen salasanan vaihdon yhteydessä.</span></p>
            <div class="alert alert-success" *ngIf="successMessage != '' ">
              <p class="text-center">{{successMessage}}</p>
            </div>
            <div class="alert alert-danger" *ngIf="errMessage != '' ">
              <p class="text-center">{{errMessage}}</p>
            </div>
          </div>
        </div>
        <div class="col-3"></div>

      </div>

      <div class="col-12 p-0 row m-0">
        <div class="col-3"></div>
        <div class="col-12 col-md-6 p-0">
          <div class="col-12 p-0 ">
            <div class="col-12 login-form-bg">
              <div id="loader" class="loader-container mt-4 mb-4" style="display:none">
                <div class="loader mx-auto"></div>
                <p class="body2b-b text-center mt-4 mb-4">Salansanaasi lisätään...</p>
              </div>
              <form class="flex-row " id="new-pwd-form" [formGroup]="form" (ngSubmit)="changePassword()">
              <div class="col-12 row m-0 pl-0 pr-0">

                <div class="form-group mb-2 flex-column col-12 p-0">
                  <input  class="form-control" formControlName="password" type="password" placeholder="Salasana">
                </div>
              </div>
              <div class="col-12 row m-0 pl-0 pr-0">

                <div class="form-group mb-2 flex-column col-12 p-0">
                  <input  class="form-control" formControlName="password2" type="password" placeholder="Salasana uudelleen">
                </div>
              </div>
              <div class="col-12 row ms-0 me-0 mt-4">
                <div class="col-1">
                  <input type="checkbox"  id="sys_checkbox">
                </div>
                <div class="col-11">
                    <p>Olen lukenut Formed Oy:n <a target="_blank" href="https://formed.fi/tietosuojaseloste">tietosuojaselosteen</a> sekä <a target="_blank" href="https://formed.fi/kayttoehdot">käyttöehdot</a> ja hyväksyn ne.</p>
                </div>
              </div>
              <div class=" mx-auto mt-4">
                <div class="text-center" >
                  <button  [disabled]="form.invalid" class="btn btn-formed-main-blue"   >Tallenna</button>
                </div>
              </div>
            </form>
          
        </div>
          </div>
        </div>
        <div class="col-3"></div>

      </div>

      <div class="d-flex justify-content-center flex-row ">
        <div class="link-container">

        </div>
      </div>
      </div>
    </div>
  </div> -->


  <div class="bg-login">
		<div class="container h-100">
		<div class="wrap text-center h-100 align-content-center">
			<div class="col-12 row m-0 p-0">
				<div class="col-3"></div>
				<div class="col-12 col-lg-6 bg-f-w justify-content-center z-100">
					<div class="col-12 m-0 row">
						<div class="col-1"></div>
						<div class="col-12 col-md-10 p-0 mt-4">
							<div class="col-12 text-center p-0 mt-4">
								<img src="../../assets/images/formed_favicon_white.png" alt="" height="76" class="mx-auto">
								<h4 class="semiboldtextblue70020 mt-4">Uusi salasana</h4>
								<p class="normaltextblue80016 mt-2">Lisää turvallinen salasanasi. Salasanan tulee olla vähintään 8 merkkiä.</p>
							</div>
						</div>
						<div class="col-1"></div>
			
					</div>
			
					<div class="col-12 p-0 row m-0">
						<div class="col-1"></div>
						<div class="col-12 col-md-10 p-0">
							<div class="col-12 p-0 ">
                <div class="col-12 login-form-bg">
                  <div id="loader" class="loader-container mt-4 mb-4" style="display:none">
                    <div class="loader mx-auto"></div>
                    <p class="body2b-b text-center mt-4 mb-4">Salansanaasi lisätään...</p>
                  </div>
                  <form class="flex-row " id="new-pwd-form" [formGroup]="form" (ngSubmit)="changePassword()">
                  <div class="col-12 row m-0 pl-0 pr-0">
    
                    <div class="form-group mb-2 flex-column col-12 p-0">
                      <input  class="form-control" formControlName="password" type="password" placeholder="Salasana">
                    </div>
                  </div>
                  <div class="col-12 row m-0 pl-0 pr-0">
    
                    <div class="form-group mb-2 flex-column col-12 p-0">
                      <input  class="form-control" formControlName="password2" type="password" placeholder="Salasana uudelleen">
                    </div>
                  </div>
                  <div class="col-12 row ms-0 me-0 mt-2">
                    <div class="col-1">
                      <input type="checkbox" class="mt-2"  id="sys_checkbox">
                    </div>
                    <div class="col-11">
                        <p class="text-start normaltextblue16">Olen lukenut Formed Oy:n <a target="_blank" href="https://formed.fi/tietosuojaseloste">tietosuojaselosteen</a> sekä <a target="_blank" href="https://formed.fi/kayttoehdot">käyttöehdot</a> ja hyväksyn ne.</p>
                    </div>
                  </div>
                  <div class=" mx-auto mt-2 mb-4">
                    <div class="text-center" >
                      <button  [disabled]="form.invalid" class="btn btn-formed-main-blue w-100"   >Tallenna</button>
                    </div>
                  </div>
                </form>
              
            </div>
							</div>
						</div>
						<div class="col-1"></div>
			
					</div>
			
				</div>
				<div class="col-3"></div>
			</div>
	
		</div>
		</div>
	
	</div>